/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateUpdateAttachmentDto } from './CreateUpdateAttachmentDto';
import {
    CreateUpdateAttachmentDtoFromJSON,
    CreateUpdateAttachmentDtoFromJSONTyped,
    CreateUpdateAttachmentDtoToJSON,
} from './CreateUpdateAttachmentDto';

/**
 * 
 * @export
 * @interface CreateUpdateAttachmentsDto
 */
export interface CreateUpdateAttachmentsDto {
    /**
     * 
     * @type {Array<CreateUpdateAttachmentDto>}
     * @memberof CreateUpdateAttachmentsDto
     */
    attachmentsToAdd: Array<CreateUpdateAttachmentDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateAttachmentsDto
     */
    attachmentsToDelete?: Array<string>;
}

/**
 * Check if a given object implements the CreateUpdateAttachmentsDto interface.
 */
export function instanceOfCreateUpdateAttachmentsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "attachmentsToAdd" in value;

    return isInstance;
}

export function CreateUpdateAttachmentsDtoFromJSON(json: any): CreateUpdateAttachmentsDto {
    return CreateUpdateAttachmentsDtoFromJSONTyped(json, false);
}

export function CreateUpdateAttachmentsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateAttachmentsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachmentsToAdd': ((json['attachmentsToAdd'] as Array<any>).map(CreateUpdateAttachmentDtoFromJSON)),
        'attachmentsToDelete': !exists(json, 'attachmentsToDelete') ? undefined : json['attachmentsToDelete'],
    };
}

export function CreateUpdateAttachmentsDtoToJSON(value?: CreateUpdateAttachmentsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachmentsToAdd': ((value.attachmentsToAdd as Array<any>).map(CreateUpdateAttachmentDtoToJSON)),
        'attachmentsToDelete': value.attachmentsToDelete,
    };
}

